import { render, staticRenderFns } from "./checkbox-input.vue?vue&type=template&id=623c1509&scoped=true"
import script from "./checkbox-input.vue?vue&type=script&lang=ts"
export * from "./checkbox-input.vue?vue&type=script&lang=ts"
import style0 from "./checkbox-input.vue?vue&type=style&index=0&id=623c1509&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623c1509",
  null
  
)

export default component.exports